// Abas horizontais acessíveis (estilo Volis). `tabs` = [{ id, label }].
// `idPrefix` liga cada aba ao seu painel (`{idPrefix}-tab-{id}` / `{idPrefix}-panel-{id}`);
// sem ele as abas saem como antes, sem os atributos de ligação.
export default function Tabs({ tabs, active, onChange, idPrefix }) {
  return (
    <div className="bg-white dark:bg-slate-900 border-b border-slate-200 dark:border-slate-700 px-6">
      <div role="tablist" className="flex gap-1 -mb-px">
        {tabs.map(t => {
          const sel = active === t.id
          return (
            <button
              key={t.id}
              role="tab"
              aria-selected={sel}
              id={idPrefix ? `${idPrefix}-tab-${t.id}` : undefined}
              aria-controls={idPrefix ? `${idPrefix}-panel-${t.id}` : undefined}
              onClick={() => onChange(t.id)}
              className={`px-4 py-3 text-sm font-medium border-b-2 transition-colors ${
                sel ? 'border-brand text-brand-700 dark:text-brand-300' : 'border-transparent text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200'
              }`}
            >
              {t.label}
            </button>
          )
        })}
      </div>
    </div>
  )
}
